import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["triggerRef"];
import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import React, { useState } from 'react';
import AddManageContactModal from "../AddManageContactModal";
import { CONTACT_MODAL_ACTIONS } from "../AddManageContactModal/AddManageContactModal.types";
import DeleteContactConfirmationModal from "../DeleteContact/DeleteContactConfirmationModal";

function PartnerContactsActions(props) {
  const [deleteContactConfirmationFlag, setDeleteContactConfirmationFlag] = useState(false);
  const [showContactModal, setContactModal] = useState(false);

  const onManageContact = () => {
    toggleContactModal();
    props.onChangeAction();
  };

  const onDeleteContact = () => {
    toggleDeleteContactConfirmationFlag();
    props.onChangeAction();
  };

  const toggleDeleteContactConfirmationFlag = () => setDeleteContactConfirmationFlag(!deleteContactConfirmationFlag);

  const toggleContactModal = () => setContactModal(!showContactModal);

  return /*#__PURE__*/React.createElement(React.Fragment, null, deleteContactConfirmationFlag && /*#__PURE__*/React.createElement(DeleteContactConfirmationModal, {
    onCloseModal: toggleDeleteContactConfirmationFlag,
    contactName: props.contact.displayName,
    contactResource: props.contact._links.self.href,
    onDelete: onDeleteContact,
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId
  }), showContactModal && /*#__PURE__*/React.createElement(AddManageContactModal, {
    action: CONTACT_MODAL_ACTIONS.MANAGE,
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    onClose: toggleContactModal,
    onSubmit: onManageContact,
    contact: props.contact
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    trigger: _ref => {
      let {
        triggerRef
      } = _ref,
          triggerProps = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
        iconBefore: /*#__PURE__*/React.createElement(MoreIcon, {
          label: "more"
        }),
        ref: triggerRef
      }));
    }
  }, /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
    testId: "manageContact",
    onClick: toggleContactModal
  }, "Manage contact"), /*#__PURE__*/React.createElement(DropdownItem, {
    testId: "deleteContact",
    onClick: toggleDeleteContactConfirmationFlag
  }, "Delete contact"))));
}

export default PartnerContactsActions;